import RytmWebflow from 'rytm-webflow'
import { TimelineMax, TweenMax, Elastic, Expo, Sine, Back } from 'gsap'
import { playSound } from './../amzn/sounds'

import WebflowView from './WebflowView'
import { trace } from 'rytm-helpers'

class WorkcardView extends WebflowView {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    const wW = window.innerWidth
    const bg = container.querySelector('#workcard-bg')
    const overlay = container.querySelector('#workcard-overlay')
    const content = container.querySelector('#workcard-content')
    playSound("move_lg")
    if (bg && overlay && content) {
      let t = new TimelineMax({repeat: 0})
      t.from(bg, .4, {x: wW, ease: Expo.easeOut, onComplete: () => {
        overlay.classList.add("active")
        playSound("scotch_lg")
      }})
      t.from(content, .01, {alpha: 0})
      t.to(overlay, .4, {x: -wW, ease: Expo.easeIn, onComplete: () => {
        overlay.classList.remove("active")
        document.documentElement.classList.add("workcard-ready")
      }})
    }
    const list = [...container.querySelectorAll(".item-tr")]
    list.forEach(this.showTableRow.bind(this))
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    playSound("move_xl")
    document.documentElement.classList.remove("workcard-ready")
    const wW = window.innerWidth
    const bg = container.querySelector('#workcard-bg')
    const overlay = container.querySelector('#workcard-overlay')
    const content = container.querySelector('#workcard-content')
    if (bg && overlay && content) {      
      let t = new TimelineMax({repeat: 0})
      t.to(overlay, .01, {x: wW, delay: .2, onComplete: () => {
        overlay.classList.add("active")
      }})
      t.to(overlay, .4, {x: 0, ease: Sine.easeIn})
      t.to(content, .01, {alpha: 0, onComplete: () => {
        overlay.classList.remove("active")
      }})
      t.to(bg, .4, {x: -wW, ease: Sine.easeIn})
    }
    const list = [...container.querySelectorAll(".item-tr")]
    list.forEach(this.hideTableRow.bind(this))
  }

  
  /**
   * ##########
   * ### OWN ###
   */

  showTableRow(el, index){
    let delay = index * .1 + .8
    delay = delay > 2 ? 2 : delay
    TweenMax.from(el, .5, {x: 20, alpha: 0, ease: Expo.easeOut, delay})
  }
  hideTableRow(el, index){
    let delay = index * .01
    delay = delay > 2 ? 2 : delay
    TweenMax.to(el, .3, {x: -20, alpha: 0, ease: Expo.easeIn, delay})
  }
  
}

export default WorkcardView